export default __webpack_public_path__ + "static/media/Portrait.82b43fa1.png";